export const getRewardStatus = (status) => (status === 'allocated' ? 'available' : status);
